import { Point } from "./point";
import { Rectangle } from "./rectangle";

export class FrameLevelCellid {
  /** 階層 */
  public readonly level: number;
  /** 階層における セルの位置 */
  public readonly cellid: Point;
  public readonly toR: Rectangle;
  public readonly fromR: Rectangle;

  constructor(level: number, cellid: Point, toR: Rectangle, fromR: Rectangle) {
    this.level = level;
    this.cellid = cellid;
    this.toR = toR;
    this.fromR = fromR;
  }

  public toString(): string {
    return `{level:${this.level}, cellid:${this.cellid}, to:${this.toR}, from:${this.fromR}}`;
  }
}

//export class Cell {
//    /** 階層 */
//    public readonly level: number;
//    /** 階層における セルの座標 */
//    public readonly coordinate: Point;
//    /** セルが賄う 元画像に対する領域 */
//    public readonly rect: Rectangle;

//    public toString(): string {
//        return `{level:${this.level}, coordinate:${this.coordinate}, rect:${
//            this.rect
//            }}`;
//    }

//    constructor(level: number, coordinate: Point, rect: Rectangle) {
//        this.level = level;
//        this.coordinate = coordinate;
//        this.rect = rect;
//    }
//}

//export class Frame {
//    public readonly cell: Cell;
//    public readonly source: Rectangle;
//    public readonly dest: Rectangle;

//    constructor(cell: Cell, source: Rectangle, dest: Rectangle) {
//        this.cell = cell;
//        this.source = source;
//        this.dest = dest;
//    }

//    public toString(): string {
//        return `{cell:${this.cell}, source:${this.source}, dest:${this.dest}}`;
//    }
//}
